import React, { useContext } from 'react';

import {
	BalanceGrid,
	BorderedFocusableContainerGrid,
	EndAlignText,
	InputTokenActionButtonsGrid,
	InputTokenAmount
} from 'components/common/Styles';
import { Button, Grid, Typography } from '@material-ui/core';
import { StoreContext } from 'mobx/store-context';
import { useNumericInput } from 'utils/useNumericInput';
import { observer } from 'mobx-react-lite';
import { Token } from './index';
import { SwapState } from 'config/enums/swap-state.enum';
import { TokenBalance } from 'mobx/stores/UserStore';
import BigNumber from 'bignumber.js';

export interface SwapInputProps {
	token: Token;
	state: SwapState;
	updateInput: (change: TokenBalance, state: SwapState) => void;
	swapAmount: TokenBalance;
}

const SwapInput: React.FC<SwapInputProps> = observer((props: SwapInputProps) => {
	const store = useContext(StoreContext);
	const { token, state, updateInput, swapAmount } = props;
	const { onboard, user } = store;

	const { onValidChange, inputProps } = useNumericInput();

	const userBalance = user.getTokenBalance(token.address);

	console.log('checking: ', token, state, updateInput, swapAmount);

	const handleInputChange = (change: string) => {
		console.log(`updating input for ${token.name} in state: ${state}`);
		const inputChange: TokenBalance = {
			displayBalance: change,
			balance: new BigNumber(change).multipliedBy(1e18)
		};
		updateInput(inputChange, state);
	};

	const handleApplyMaxBalance = async (): Promise<void> => {
		if (userBalance.balance.gt(0)) {
			const balanceUpdate = {
				displayBalance: userBalance.balance.dividedBy(1e18).toFixed(6, BigNumber.ROUND_HALF_FLOOR),
				balance: userBalance.balance
			};
			updateInput(balanceUpdate, state);
		}
	};
	return (
		<>
			<BalanceGrid item xs={12}>
				<EndAlignText variant="body1" color="textSecondary">
					Balance: {userBalance.displayBalance}
				</EndAlignText>
			</BalanceGrid>
			<BorderedFocusableContainerGrid item container xs={12}>
				<Grid item xs={12} sm={5}>
					<InputTokenAmount
						inputProps={inputProps}
						disabled={!onboard.address}
						value={swapAmount?.displayBalance || ''}
						placeholder="0.000"
						onChange={onValidChange(handleInputChange)}
					/>
				</Grid>
				<InputTokenActionButtonsGrid item container spacing={1} xs={12} sm={7}>
					{state === SwapState.From ? (
						<Grid item>
							<Button
								disabled={!onboard.address}
								size="small"
								variant="outlined"
								onClick={handleApplyMaxBalance}
							>
								max
							</Button>
						</Grid>
					) : null}
					<Grid item>
						<Typography>{token.name}</Typography>
					</Grid>
				</InputTokenActionButtonsGrid>
			</BorderedFocusableContainerGrid>
		</>
	);
});

export default SwapInput;
